<template>
		<div style="background-color:#F5F5F5;width:100%;display:flex;flex-direction: column;align-items:center;">
			<div v-if="datalise!='<p><br></p>'" v-html="datalise" style="width:1200px;text-align:left;font-size:14px;"></div>
			<div style="height:60vh;line-height:60vh;" v-else>暂时没有相关内容</div>
			<div v-if="video" class="artitle_media">
				<video  preload controls style="width:500px;height: 400px;">
				      <source :src="url+video.url" type="video/mp4" v-if="video&&video.url" />
				</video>
			</div>
			<div  class="ljbms" @click="tap()">需求反馈</div>
		</div>
</template>

<script>
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name:"details",
		components:{
		},
		data() {
			return {
				videurl:'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4',
				url:'https://www.baidu.com/',
				tabIndex:7,
				tabIndexs:0,
				data:'',
				pid:'',
				datalise:'',
				datasy:'',
				video:'',
				url:'',
				dh:[
					{a:'首页'},
					{a:'活动'},
					{a:'研究'},
					{a:'学院'},
					{a:'人物视界'},
					{a:'融资并购'},
					{a:'转移转化'},
				],
				
			}
		},
		created() {
			this.$store.commit("navbgshow",9)
			this.$store.commit("meetingshow",0)
			this.$store.commit("business",0)
			this.pid=this.$route.query.data
			this.data=this.$route.query.datas
			//获取	news 为三级分类文章
			if(this.data==0){
				this.ymxra()
			}else
			//获取home_news 为首页文章
			if(this.data==1){
				this.ymxrb()
			}else
			//获取meeting_new 为最新会议文章
			if(this.data==2){
				this.ymxrc()
			}else
			//获取train_new 为最新培训文章
			if(this.data==3){
				this.ymxrd()
			}else
			//获取online_new 为线上活动文章
			if(this.data==5){
				this.ymxre()
			}else 
			//获取研究
			if(this.data==6){
				this.ymxrf()
			}else
			//获取学院
			if(this.data==7){
				this.ymxrg()
			}else
			//获取人物视界
			if(this.data==8){
				this.ymxrh()
			}else
			//获取产品推荐
			if(this.data==9){
				this.ymxri()
			}else
			//获取资源对接
			if(this.data==10){
				this.ymxrp()
			}else
			//获取活动
			if(this.data==11){
				this.ymxro()
			}
			else{
				this.datalise=this.$route.query.datasy.info
			}
		},
		methods: {
			tap:function(){
				this.$store.commit("collgepx",0)
				this.$store.commit("business",1)
				this.$router.push({name:'sign'});
				this.$store.commit("navbgshow",9)
			},
			//获取活动
			ymxro:function(){
				axios({
				    url: `${base.url}/api/user/getDetails`,
				    method: 'post',
				    data:{id:this.pid,table:"shaky"}
				}).then((res) => {
					// if(res.data.src!=''){
					// 	if(res.data.src.indexOf("http")!=-1){
					// 	   window.location.href=res.data.src
					// 	}
					// 	// window.open(res.data.src, "_blank")
					// }
					this.datalise=res.data.info
					this.url=res.url
					console.log(res);
					if(res.data.video.length!=0){
						this.video=res.data.video[0]
					}
				        })
			},
			//获取资源对接
			ymxrp:function(){
				axios({
				    url: `${base.url}/api/user/getDetails`,
				    method: 'post',
				    data:{id:this.pid,table:"resources_news"}
				}).then((res) => {
					// if(res.data.src!=''){
					// 	if(res.data.src.indexOf("http")!=-1){
					// 	   window.location.href=res.data.src
					// 	}
					// 	// window.open(res.data.src, "_blank")
					// }
					this.datalise=res.data.info
					this.url=res.url
					console.log(res);
					if(res.data.video.length!=0){
						this.video=res.data.video[0]
					}
				        })
			},
			//获取产品推荐
			ymxri:function(){
				axios({
				    url: `${base.url}/api/user/getDetails`,
				    method: 'post',
				    data:{id:this.pid,table:"product_new"}
				}).then((res) => {
					// if(res.data.src!=''){
					// 	if(res.data.src.indexOf("http")!=-1){
					// 	   window.location.href=res.data.src
					// 	}
					// 	// window.open(res.data.src, "_blank")
					// }
					this.datalise=res.data.info
					this.url=res.url
					if(res.data.video.length!=0){
						this.video=res.data.video[0]
					}
				        })
			},
			//获取人物视界
			ymxrh:function(){
				axios({
				    url: `${base.url}/api/user/getDetails`,
				    method: 'post',
				    data:{id:this.pid,table:"character"}
				}).then((res) => {
					this.datalise=res.data.info
					this.url=res.url
					if(res.data.video.length!=0){
						this.video=res.data.video[0]
					}
				        })
			},
			//获取	学院
			ymxrg:function(){
				axios({
				    url: `${base.url}/api/user/getDetails`,
				    method: 'post',
				    data:{id:this.pid,table:"college"}
				}).then((res) => {
					// if(res.data.src!=''){
					// 	if(res.data.src.indexOf("http")!=-1){
					// 	   window.location.href=res.data.src
					// 	}
					// 	// window.open(res.data.src, "_blank")
					// }
					this.datalise=res.data.info
					this.url=res.url
					if(res.data.video.length!=0){
						this.video=res.data.video[0]
					}
				        })
			},
			//获取	研究
			ymxrf:function(){
				axios({
				    url: `${base.url}/api/user/getDetails`,
				    method: 'post',
				    data:{id:this.pid,table:"research"}
				}).then((res) => {
					this.datalise=res.data.info
					this.url=res.url
					if(res.data.video.length!=0){
						this.video=res.data.video[0]
					}
				        })
			},
			//获取	news 为三级分类文章
			ymxra:function(){
				axios({
				    url: `${base.url}/api/user/getDetails`,
				    method: 'post',
				    data:{id:this.pid,table:"news"}
				}).then((res) => {
					// if(res.data.src!=''){
					// 	if(res.data.src.indexOf("http")!=-1){
					// 	   window.location.href=res.data.src
					// 	}
					// 	// window.open(res.data.src, "_blank")
					// }
					this.datalise=res.data.info
					this.url=res.url
					if(res.data.video.length!=0){
						this.video=res.data.video[0]
					}
				        })
			},
			//获取home_news 为首页文章
			ymxrb:function(){
				axios({
				    url: `${base.url}/api/user/getDetails`,
				    method: 'post',
				    data:{id:this.pid,table:'home_news'}
				}).then((res) => {
					// if(res.data.src!=''){
					// 	if(res.data.src.indexOf("http")!=-1){
					// 	   window.location.href=res.data.src
					// 	}
					// 	// window.open(res.data.src, "_blank")
					// }
					console.log(res);
					this.datalise=res.data.info
					this.url=res.url
					if(res.data.video.length!=0){
						this.video=res.data.video[0]
					}
				        })
			},
			//获取meeting_new 为最新会议文章
			ymxrc:function(){
				axios({
				    url: `${base.url}/api/user/getDetails`,
				    method: 'post',
				    data:{id:this.pid,table:'meeting_new'}
				}).then((res) => {
					// if(res.data.src!=''){
					// 	if(res.data.src.indexOf("http")!=-1){
					// 	   window.location.href=res.data.src
					// 	}
					// 	// window.open(res.data.src, "_blank")
					// }
					this.datalise=res.data.info
					this.url=res.url
					if(res.data.video.length!=0){
						this.video=res.data.video[0]
					}
				        })
			},
			//获取train_new 为最新培训文章
			ymxrd:function(){
				axios({
				    url: `${base.url}/api/user/getDetails`,
				    method: 'post',
				    data:{id:this.pid,table:'train_new'}
				}).then((res) => {
					// if(res.data.src!=''){
					// 	if(res.data.src.indexOf("http")!=-1){
					// 	   window.location.href=res.data.src
					// 	}
					// 	// window.open(res.data.src, "_blank")
					// }
					this.datalise=res.data.info
					this.url=res.url
					if(res.data.video.length!=0){
						this.video=res.data.video[0]
					}
				        })
			},
			//获取online_new 为线上活动文章
			ymxre:function(){
				axios({
				    url: `${base.url}/api/user/getDetails`,
				    method: 'post',
				    data:{id:this.pid,table:'online_new'}
				}).then((res) => {
					// if(res.data.src!=''){
					// 	if(res.data.src.indexOf("http")!=-1){
					// 	   window.location.href=res.data.src
					// 	}
					// 	// window.open(res.data.src, "_blank")
					// }
					console.log(res);
					this.datalise=res.data.info
					this.url=res.url
					if(res.data.video.length!=0){
						this.video=res.data.video[0]
					}
				        })
			},
		},
	}
</script>

<style lang="scss" scoped>
	.artitle_media{
	    text-align: center;
		margin-top:20px;
	}
	.artitle_media video{
	    object-fit:fill;
	    width:100%;
	    height:100%;
	    margin-left: auto;
	    margin-right: auto;
		outline:none
	}
	.ljbms{
		background-color:#20919D;
		width: 340px;
		height: 38px;
		color: white;
		line-height:38px;
		margin-top:50px;
	}
	.ljbms:hover{
		cursor:pointer;
	}
	.artitle_media{
	    text-align: center;
	}
	.artitle_media video{
	    object-fit:fill;
	    width:100%;
	    height:100%;
	    margin-left: auto;
	    margin-right: auto;
	    margin-bottom: 50px;
		outline:none
	}
	.zwk{
		margin:0px 10px 0px 0px;
		width: 348px;
		height:695px;
		background-color:#ffffff;
	}
	.zwk2{
		width: 1150px;
		height:695px;
		background-color:#ffffff;
	}
	.color{
		color: #FFFFFF;
		width:135px;
		height:42px;
		line-height: 42px;
		text-align: center ;
	}
	.serch{
		color:#FFFFFF;
		font-size:10px;
		background-color:#20919D;
		text-align:center;
		height: 31px;
		line-height:31px;
		width:50px;
	}
	.flex{
		display:flex;
	}
	.flexjust{
		justify-content: center;
	}
	.flexali{
		align-items: center;
	}
	.colorwhite{
		color: #FFFFFF;
	}
	.dhl{
		color:#FFFFFF;
		font-size:15px;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.dhls{
		color:#FFFFFF;
		font-size:15px;
		background-color: #59D4CF;
		display:flex;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.Line{
		width:1px;
		height: 14px;
		background-color:#FFFFFF;
	}
	.font{
		font-size:14px;
	}
	.por{
		display:flex;
		flex-direction: column;
		margin-left:10px;
	}
	.bodya{
		background-color:#5AD6CE;
		width:100px;
		height:86.9px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.iur{
		margin-left: 5px;
	}
	.bjtop{
		margin-top: 10px;
	}
	.bjleft{
		margin-left:10px;
	}
	.bjright{
		margin-right:10px;
	}
	.bjbottom{
		margin-bottom:10px;
	}
	.zxls{
		text-align: left;
		color:#181818;
		font-size:16px;
	}
	.router-link-active {
	  text-decoration: none;
	}
	a {
	  text-decoration: none;
	}
</style>
